import AssignTrainer from "../../features/admin/AssignTrainer"

const AssignTranerPage = () => {
  return <AssignTrainer/>
}

export default AssignTranerPage